<div class="contents" [class.invisible]="showSpinner()">
  <ng-content></ng-content>
</div>
@if(showSpinner()) {
<mat-spinner mode="indeterminate"
             [diameter]="diameter()"
             class="absolute top-1/2 left-1/2 -translate-1/2 {{spinnerClasses()}}"></mat-spinner>
}